import { badgePropsSchema } from '../component-catalog.js';
export const badgeDefinition = {
    type: 'Badge',
    category: 'content',
    propsSchema: badgePropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Inline label pill for tags or status. Props: text (required), color?.',
};
//# sourceMappingURL=Badge.js.map